import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { Pagination, Input, Row, Col, Select, Form, DatePicker, message, Space } from 'antd';
import { CSVLink } from 'react-csv';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { dateConverter } from '../../utils/utcDateConversion';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import getCauseByOrg from '../../hooks/getCauseByOrg';
import useFetchCauses from '../../hooks/fetchCauses';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import NoRecordFound from '../../components/common/NoRecordFound';

function DonationHistory() {
  const donorId = JSON.parse(localStorage.getItem('donorId'));
  const user = JSON.parse(localStorage.getItem('user'));
  const storageCause = localStorage.getItem('causeId');
  if (storageCause == 'undefined') localStorage.removeItem('causeId');
  // console.log(storageCause)
  const org = localStorage.getItem('org');
  const orgId = org ? Number(org) : null;
  let organizationId = org ? Number(org) : null;
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  let searchedUser;
  const token = getTokenfromUserObj();
  function goBack() {
    if (user.userType === 'A') navigate('/donor/view', { replace: true });
    else if (user.userType === 'O') navigate('/orgreport/donors', { replace: true });
  }
  window.addEventListener('popstate', goBack);
  const [form] = Form.useForm();
  const [getLIst, setGetList] = useState(false);
  const [reportObj, setReportObj] = useState({});
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchAllTransactions, setFetchAllTransactions] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [pageSize, setPageSize] = useState(10)
  const [selectedCauseId, setSelectedCauseId] = useState();
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState();
  const [tableShow, setTableShow] = useState(true);
  const [isOrg, setisOrg] = useState(false);
  const [donorObj, setDonorObj] = useState({});
  const [show, setShow] = useState(false);
  const [status,setStatus]=useState([])
  const [causeList, setCauseList] = useState([]);
  const [err, setErr] = useState('');
  let cause = localStorage.getItem('causeId');
    cause = cause ? Number(cause) : null;
  const u = useFetchUsers();
  console.log(u);
  const userCount = u.response ? u.response.data.length : 0;
  console.log(userCount);
  console.log(reportObj)
  const getAllTransactions=async(obj)=>{
    console.log("Get all transactions")
    let payloadObj={
      limit:null,
      offset:null,
      organizationId: user.userType === 'A' ? obj.organizationId : user.organizationId,
    }
    if(organizationId)payloadObj.organizationId = organizationId;
    
    payloadObj.startDate = reportObj.startDate;
    payloadObj.endDate = reportObj.endDate;
    payloadObj.status=status?status:null;
    payloadObj.donorId=donorId&&window.location.pathname === '/orgdonor/donationhistory'?donorId:null;
    if(window.location.pathname === '/donor/donationhistory' && user.userType === 'A')payloadObj.donorId=donorId;
    payloadObj.causeId=obj.causeId?obj.causeId:cause;
    console.log(payloadObj);
    let dateConv;
    let searchQuery = user.userType=="A"?`${app.URL}/trans/searchtrans`:`${app.URL}/trans/searchtransbyorg/${user.organizationId}`;
      const transResp = await axios.post(searchQuery, payloadObj, { headers: { auth: token } });
      console.log(transResp);
      transResp.data ? (dateConv = dateConverter(transResp?.data?.data?.data, 'donationDate')) : ' ';
      transResp.data ? setFetchAllTransactions(dateConv):[];
  }
  useEffect(() => {
    if (localStorage.getItem('org')) {
      setSelectedCauseId(localStorage.getItem('org'));
      setisOrg(true);
    }
    if (!localStorage.getItem('org')) setisOrg(false);

// Get all transactions from db    
    getAllTransactions();
  }, []);

  console.log(fetchAllTransactions)
  console.log('selected cause iD',selectedCauseId)
  let causeResp;
  if (user.userType === 'O') causeResp = getCauseByOrg(user.organizationId);
  else if (user.userType === 'A') causeResp = useFetchCauses();
  let causeObj = causeResp.response ? causeResp.response.data : [];
  // if(!selectedCauseId)setCauseList(causeObj);
  let orgResp;
  let orgObj;


  if (user.userType === 'A') {
    orgResp = useFetchOrganizations();
    console.log(orgResp);
    orgObj = orgResp.response ? orgResp.response.data : [];
    console.log(orgObj);
    console.log(window.location.pathname);
  }
  let newStartDate,newEndDate;
  let amount = 0;
 

  const fetchData = async (obj) => {
    console.log('fetchData');
    const limit = obj.limit?obj.limit:10;
    const offset = obj.offset?obj.offset:0;
    if(selectedCauseId)obj.organizationId = selectedCauseId;
    console.log(cause);
    obj.limit = limit;
    obj.offset = offset;
    obj.organizationId = user.userType === 'A' ? obj.organizationId : user.organizationId;
    obj.startDate = reportObj.startDate;
    obj.endDate = reportObj.endDate;
    obj.status=status;
    obj.donorId=donorId&&window.location.pathname === '/orgdonor/donationhistory'?donorId:null;
    if(window.location.pathname === '/donor/donationhistory' && user.userType === 'A')obj.donorId=donorId;
    obj.causeId=obj.causeId?obj.causeId:cause;
    console.log(obj);
    if (reportObj.startDate > reportObj.endDate) return;
    let searchQuery;
    console.log(obj);

    if (window.location.pathname === '/orgreport/donation' && user.userType === 'O') searchQuery = `${app.URL}/trans/searchtransbyorg/${user.organizationId}`;
    if (window.location.pathname === '/reports/donation' && user.userType === 'A') searchQuery = `${app.URL}/trans/searchtrans`;
    if (window.location.pathname === '/donor/donationhistory' && user.userType === 'A') searchQuery = `${app.URL}/trans/searchtrans`;
    if (window.location.pathname === '/orgdonor/donationhistory' && user.userType === 'O') searchQuery = `${app.URL}/trans/searchtransbyorg/${user.organizationId}`;
    console.log(searchQuery);
    console.log(obj);
    const transResp = await axios.post(searchQuery, obj, { headers: { auth: token } });
    console.log(transResp);
    let dateConv;
    transResp.data ? (dateConv = dateConverter(transResp?.data?.data?.data, 'donationDate')) : ' ';
    transResp.data ? setCurrent(1) : 0;
    transResp.data ? setPagesCount(transResp?.data?.data?.count) : console.log(0);
    transResp.data ? setRenderList(dateConv): [];
    setGetList(false);
  };
  useEffect(() => {
  fetchData(reportObj);
  getAllTransactions(reportObj);
  }, [getLIst,window.location.pathname,selectedCauseId]);

  fetchAllTransactions
    ? fetchAllTransactions.map((ele) => {
      console.log(ele)
        if (ele.status === 'Approved' || ele.status === 'Settled') {
          return (amount += Number(ele.amount)+Number(ele.serviceFee));
        }
      })
    : ' ';
  amount = amount.toFixed(2);
  console.log('amount ' + amount);
  const handleStatusChange=(value)=>{
    setStatus(value)
  }
  const onFinish = (values) => {
    console.log('Success:', values);
    if (values.startDate) {
      newStartDate = values.startDate ? values.startDate._d.toUTCString() : null;
      newStartDate = newStartDate ? new Date(newStartDate).toISOString().slice(0, 19).replace('T', ' ') : ' ';
      if (values.endDate) {
        newEndDate = values.endDate ? values.endDate._d.toUTCString() : null;
        newEndDate = newEndDate ? new Date(newEndDate).toISOString().slice(0, 19).replace('T', ' ') : ' ';
      }
    }
    if (newStartDate > newEndDate) message.error('Start Date must be less than or equal to end date');
    setReportObj({
      causeId:values.causeId?values.causeId:null,
      organizationId: values.organizationId ? values.organizationId : null,
      startDate: values.startDate ? newStartDate.slice(0, 10) + ' 00:00:00' : null,
      endDate: values.endDate ? newEndDate.slice(0, 10) + ' 23:59:59' : null,
    });
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  console.log(reportObj);
  const handleClearClick = () => {
    console.log('handleClearClick');
    localStorage.removeItem('causeId');
    localStorage.removeItem('org');
    localStorage.removeItem('donorId');
    cause=null
    setReportObj({})
    setSelectedCauseId(null);
    setStatus([])
    form.resetFields();
    setGetList(true);
  };
  useEffect(() => {
    if (Object.keys(reportObj).length > 0){
      fetchData(reportObj);
      getAllTransactions(reportObj);
    } 
  }, [reportObj]);
  console.log(!localStorage.getItem('causeId'));
  console.log(!localStorage.getItem('org') && !localStorage.getItem('causeId'));

  const handleOrganizationClickChange = (e) => {
    console.log(e);
    setSelectedCauseId(e);
  };
  useEffect(() => {
    console.log('Selected cause id hahahah');
    const getCausesByOrg = async () => {
      console.log('Selected cause id ');
      console.log(selectedCauseId === 'undefined');
      let fetchQuery = `${app.URL}/cause/viewbyorg?orgId=${selectedCauseId}`;
      console.log(fetchQuery);
      const causeResp = selectedCauseId ? await axios.get(fetchQuery, { headers: { auth: token } }) : '';
      console.log('🚀 ~ file: Users.js:31 ~ userList ~ userResp', causeResp.data);
      causeResp.data ? setCauseList(causeResp.data.data) : ' ';
    };

    getCausesByOrg();
  }, [selectedCauseId]);
  const onChange = async (page, pageSize) => {
    console.log(pageSize)
    console.log(page);
    setCurrent(page);
    setPageSize((prev)=>(prev,pageSize))
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    user?.userType=="A"&&setReportObj({
      organizationId:reportObj.organizationId?reportObj.organizationId:null,
      causeId:reportObj.causeId?reportObj.causeId:null,
      status,
      organizationId:user?.user?.organizationId,
      startDate: reportObj.startDate?reportObj.startDate:null,
      endDate: reportObj.endDate?reportObj.endDate:null,
      limit:pageSize,
      offset:limit * (page - 1)
    })
    user?.userType=="O"&&setReportObj({
      causeId:reportObj.causeId?reportObj.causeId:null,
      status,
      organizationId:user?.user?.organizationId,
      startDate: reportObj.startDate?reportObj.startDate:null,
      endDate: reportObj.endDate?reportObj.endDate:null,
      limit:pageSize,
      offset:limit * (page - 1)
    })

    fetchData(reportObj)

  };
  console.log(pageSize)
  const userInfo = async (donorId) => {
    console.log(donorId);
    let fetchApi = `${app.URL}/user/getuserdonor/${donorId}`;
    const donorResp = await axios.get(fetchApi, { headers: { auth: token } });
    console.log(donorResp.data.data);
    const donorObj = donorResp.data ? donorResp.data.data : {};
    setDonorObj(donorObj);
    setShow(true);
  };
  

  // const handleSearch = async () => {
  //   console.log('calling');
  //   try {
  //     const result = search ? await axios.get(`${app.URL}/user/search/${search}`) : [];
  //     console.log(result);
  //     searchedUser = result.data.data;
  //   } catch (e) {
  //     console.log('Error');
  //     if (e.message) setErr(e.response.data.message);
  //     setTableShow(false);
  //   }

  //   console.log(searchedUser);
  //   if (searchedUser) {
  //     setSearchShow(true);
  //     setRenderList(searchedUser);
  //   }
  //   console.log(searchedUser);
  // };
  // const onSearch = async (value) => {
  //   console.log(value);
  //   try {
  //     const result = await axios.get(`${app.URL}/user/search/${value}`);
  //     console.log(result);
  //     searchedUser = result.data.data;
  //     setRenderList(searchedUser);
  //     setPagesCount(searchedUser.length);
  //   } catch (e) {
  //     console.log('Error');
  //     if (e.message) setErr(e.response.data.message);
  //     setTableShow(false);
  //   }
  // };


  // const handleSearchChange = (e) => {
  //   console.log(e.target.value);
  //   if (!e.target.value) {
  //     setRenderList(fetchUsers.slice(0, 10));
  //     //  console.log(organizations.length)
  //     setPagesCount(fetchUsers.length);
  //     setTableShow(true);
  //   }
  //   setSearch(e.target.value);
  // };

  // const editUser = (e) => {
  //   console.log(e);
  //   localStorage.setItem('getUserId', JSON.stringify(e.userId));
  //   navigate('/user/edit', { replace: true });
  // };
  // const addUser = () => {
  //   navigate('/user/add', { replace: true });
  // };
  // console.log(renderList);
  // const handleClose = () => setShow(false);

  // const userInfo = async (object) => {
  //   console.log(object);
  //   console.log(object.donorId);
  //   let fetchApi = `${app.URL}/user/getuserdonor/${object.donorId}`;
  console.log(fetchAllTransactions);
  let gap=user.userType=='A'?`gap-1`:`gap-3`
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-12 text-left py-2 fs-3 fw-bold'>Donation Report</div>
        <div className='col-lg-12 col-md-12'>
          <Form
            name='basic'
            form={form}
            initialValues={{
              remember: true,
              ['organizationId']: organizationId ? organizationId : null,
              ['causeId']: cause,
            }}
            className={`d-flex flex-start ${gap} flex-wrap`}
            // style={{flex: '0 1 auto',flexBasis:"content"}}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <div>
            {user && user.userType == 'A' ? (
              <Form.Item
                colon={false}
                // label='Organization'
                name='organizationId'
                rules={[
                  {
                    required: false,
                    message: 'Select Organization',
                  },
                ]}
              >
                <Select
                  // listHeight={250}
                  // listItemHeight={500}
                  onChange={handleOrganizationClickChange}
                  style={{
                    maxWidth: '12rem',
                  }}
                  placeholder='Select Organization'
                >
                  {orgObj &&
                    orgObj.map((orgs) => {
                      return (
                        <Option key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            ) : (
              ' '
            )}
            </div>
            <div>
            <Form.Item
              // style={{ width: '700px' }}
              colon={false}
              // label='Organization'
              name='causeId'
          
              rules={[
                {
                  required: false,
                  message: 'Select Cause',
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                // onChange={(causeId)=>{setCauseId(causeId)}}
                style={{
                  maxWidth: '10rem',
                }}
                placeholder='Select Cause'
              >
                {causeList.length > 0
                  ? causeList.map((orgs) => {
                      return (
                        <Option key={orgs.causeId} value={orgs.causeId}>
                          {orgs.cause}
                        </Option>
                      );
                    })
                  : causeObj.map((orgs) => {
                      return (
                        <Option key={orgs.causeId} value={orgs.causeId}>
                          {orgs.cause}
                        </Option>
                      );
                    })}
                :
              </Select>
            </Form.Item>
            </div>
            <div>
            <Form.Item
              colon={false}
              // style={{
              //   maxWidth: 140,
              // }}
              name='startDate'
              rules={[
                {
                  required: false,
                  message: 'Please select date!',
                },
              ]}
            >
              <DatePicker placeholder='Date From' />
            </Form.Item>
            </div>
            <div>
            <Form.Item
              colon={false}
              name='endDate'
              // style={{
              //   maxWidth: 140,
              // }}
              rules={[
                {
                  required: false,
                  message: 'Please select date!',
                },
              ]}
            >
              <DatePicker placeholder='Date To' />
            </Form.Item>
            </div>
            <Form.Item>
              {/* <Space
    style={{
      width: '100%',
    }}
    direction="vertical"
  > */}
              <Select
                name='status'
                mode='multiple'
                direction='vertical'
                allowClear
                // style={{
                //   width: '100%',
                // }}
                style={{
                  maxWidth: '8rem',
                }}
                placeholder='Select Status'
                defaultValue={[]}
                onChange={handleStatusChange}
                onClear={()=>setGetList(true)}
                value={status}
                options={[
                  { label: 'Approved', value: 'Approved' },
                  { label: 'Settled', value: 'Settled' },
                  { label: 'In progress', value: 'In progress'},
                  { label: 'Incomplete', value: 'Incomplete'},
                  { label: 'Declined', value: 'Declined'},
                  { label: 'Cancelled', value: 'Cancelled'}
                ]}
              />
              {/* </Space> */}
            </Form.Item>
            <Form.Item colon={false} style={{ maxWidth: '5rem' }}>
              <button className='btn btn-primary button' onClick={handleClearClick}>
                Clear
              </button>
            </Form.Item>
            <Form.Item colon={false} style={{ maxWidth: '6rem' }} >
              <button type='primary' class='btn btn-primary button' htmlType='submit'>
                Search
              </button>
            </Form.Item>
            {/* <button> */}
           
           <Form.Item style={{maxWidth:'3rem',overflow:"hidden"}}>
            <CSVLink style={{width:'3rem'}} icon={faFileExcel} filename={'donation-report.csv'} data={fetchAllTransactions}>
            <img src='/excel.png' /> 
          </CSVLink> 
          </Form.Item>
          </Form>
        
        </div>
        <div style={{ marginTop: '-20px' }} >
          
        </div>
        {/* <div className='col-lg-12 col-md-12'>Donation Amount:$ {amount}</div> */}
        <div className='col-md-12'>
          <div className='styled-table' style={{ overflowX: 'auto' }}>
            <table class='table text-black'>
              <thead class='thead-light'>
                <tr>
                  {/* <th>{t("ID")}</th> */}
                  <th style={{ width: '140px' }}>{t('Payment ID')}</th>
                  <th>{t('Name')}</th>
                  <th>{t('Card Type')}</th>
                  <th>{t('Last 4 Dig. ')}</th>
                  <th>{t('Donation')}</th>
                  <th>{t('Service Fee')}</th>
                  {user.userType === 'A' ? <th>{t('Organization')}</th> : ''}
                  <th>{t('Cause')}</th>
                  <th>{t('Donated On')}</th>
                  {user.userType === 'O' ? <th>{t('Payment Method')}</th>:''}
                  <th>{t('Kiosk Title')}</th>
                  <th>{t('Status')} </th>
                </tr>
              </thead>
              <tbody>
                {renderList
                  ? renderList.map((output) => (
                      //                 // onClick={()=>{editUser(output)}}
                      <tr className='row-hover'>
                        {/* <td >{output.userId}</td> */}
                        {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                      <td style={{ width: '120px' }}>{output.paymentId ? output.paymentId :'-'}</td>
                        <td
                          style={{ width: '200px' }}
                          onClick={() => {
                            userInfo(output.donorId);
                          }}
                        >
                          <a style={{ color: 'blue', textDecoration: 'underline' }}>
                            {output.firstName ? output.firstName : ' '} {output.lastName ? output.lastName : ' '}
                          </a>
                        </td>
                      <td style={{ width: '120px' }}>{output.cardType ? output.cardType:'-'}</td>
                      <td style={{ width: '160px' }}>{output.last4 ? output.last4 :'-'}</td>
                        {/* <td style={{width:"160px"}}>{output.currency?output.currency:"USD"} {output.amount}</td> */}
                        <td style={{ width: '120px' }}>
                        {output.currency === 'USD' ? '$' : '$'} {output.amount ? output.amount : '-'}
                        </td>
                        <td style={{ width: '120px' }}>
                          {output.currency === 'USD' ? '$' : '$'} {output.serviceFee ? (output.serviceFee <= 0.009 && output.serviceFee > 0 ? Number(output.serviceFee).toFixed(4) : Number(output.serviceFee).toFixed(2)) : '0.00'}
                        </td>
                        {user.userType === 'A' ? <td style={{ width: '160px' }}>{output.organizationName}</td> : ''}
                      <td style={{ width: '170px' }}>{output.cause ? output.cause :'-'}</td>
                        <td style={{ width: '160px' }}>{output.donationDate}</td>
                        {user.userType=='O'?<td style={{ width: '120px' }}>{output.paymentMethod}</td>:''}
                      <td style={{ width: '160px' }}>{output.kioskTitle ? output.kioskTitle:'-'}</td>
                        <td style={{ width: '150px' }}>{output.status}</td>
                        {/* <td> */}
                        {/* <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={()=>{editUser(output)}} /> */}
                        {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                        {/* </td> */}
                      </tr>
                    ))
                  : ' '}
              </tbody>
            </table>
            {renderList && renderList.length == 0 ? <NoRecordFound /> : ' '}
          </div>
          <Pagination style={{ marginTop: '10px' }} onChange={(page,pageSize)=>onChange(page,pageSize)} showSizeChanger defaultCurrent={current} showTotal={(pagesCount)=>`Total ${pagesCount} items`} pageSize={pageSize} total={pagesCount} />
        </div>
      </div>
    </div>
    // <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
    //   <div className='row mt-2'>
    //     <div className='col-lg-12 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Donation Report')}</div>
    //     <div className='row mt-3 ml-1'>
    //       <Form
    //         name='basic'
    //         form={form}
    //         labelCol={{
    //           span: 8,
    //         }}
    //         wrapperCol={{
    //           span: 8,
    //         }}
    //         style={{ alignItems: 'center' }}
    //         // style={{
    //         //   maxWidth: 600,
    //         // }}
    //         initialValues={{
    //           remember: true,
    //           ['organizationId']: organizationId ? organizationId : null,
    //           ['causeId']: causeId ? causeId : null,
    //         }}
    //         onFinish={onFinish}
    //         onFinishFailed={onFinishFailed}
    //         autoComplete='off'
    //       >
    //         <Row gutter={[16, 16]}>
    //           {user.userType === 'A' ? (
    //             <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={5}>
    //               <Form.Item
    //                 style={{ width: '750px' }}
    //                 colon={false}
    //                 // label='Organization'
    //                 name='organizationId'
    //                 rules={[
    //                   {
    //                     required: false,
    //                     message: 'Select Organization',
    //                   },
    //                 ]}
    //               >
    //                 <Select
    //                   listHeight={250}
    //                   listItemHeight={500}
    //                   onChange={handleOrganizationClickChange}
    //                   style={{
    //                     width: 220,
    //                   }}
    //                   placeholder='Select Organization'
    //                 >
    //                   {orgObj.map((orgs) => {
    //                     return (
    //                       <Option key={orgs.organizationId} value={orgs.organizationId}>
    //                         {orgs.organizationName}
    //                       </Option>
    //                     );
    //                   })}
    //                 </Select>
    //               </Form.Item>
    //             </Col>
    //           ) : (
    //             ' '
    //           )}
    //           <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={4}>
    //             <Form.Item
    //               style={{ width: '700px' }}
    //               colon={false}
    //               // label='Organization'
    //               name='causeId'
    //               rules={[
    //                 {
    //                   required: false,
    //                   message: 'Select Cause',
    //                 },
    //               ]}
    //             >
    //               <Select
    //                 listHeight={250}
    //                 listItemHeight={500}
    //                 style={{
    //                   width: 160,
    //                 }}
    //                 placeholder='Select Cause'
    //               >
    //                 {causeList.length > 0
    //                   ? causeList.map((orgs) => {
    //                       return (
    //                         <Option key={orgs.causeId} value={orgs.causeId}>
    //                           {orgs.cause}
    //                         </Option>
    //                       );
    //                     })
    //                   : causeObj.map((orgs) => {
    //                       return (
    //                         <Option key={orgs.causeId} value={orgs.causeId}>
    //                           {orgs.cause}
    //                         </Option>
    //                       );
    //                     })}
    //                 :
    //               </Select>
    //             </Form.Item>
    //           </Col>
    //           <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={4}>
    //             <Form.Item
    //               colon={false}
    //               style={{
    //                 width: 150,
    //               }}
    //               name='startDate'
    //               rules={[
    //                 {
    //                   required: false,
    //                   message: 'Please select date!',
    //                 },
    //               ]}
    //             >
    //               <DatePicker placeholder='Date From' />
    //             </Form.Item>
    //           </Col>
    //           <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={4}>
    //             <Form.Item
    //               colon={false}
    //               name='endDate'
    //               style={{
    //                 width: 550,
    //               }}
    //               rules={[
    //                 {
    //                   required: false,
    //                   message: 'Please select date!',
    //                 },
    //               ]}
    //             >
    //               <DatePicker placeholder='Date To' />
    //             </Form.Item>
    //           </Col>
    //           <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={2}>
    //             <Form.Item colon={false}>
    //               <button className='btn btn-primary button' onClick={handleClearClick}>
    //                 Clear
    //               </button>
    //             </Form.Item>
    //           </Col>

    //           <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={2}>
    //             <Form.Item colon={false}>
    //               <button type='primary' class='btn btn-primary button' htmlType='submit'>
    //                 Search
    //               </button>
    //             </Form.Item>
    //           </Col>
    //           <Col style={{ paddingLeft: '0px', paddingRight: '0px' }} span={2}>
    //             <CSVLink className='excel-btn' icon={faFileExcel} filename={'donation-report.csv'} data={fetchUsers}>
    //               <img style={{ marginTop: '-5px' }} src='/excel.png' />
    //             </CSVLink>
    //             {/* <Button><CSVLink  filename={"donation-report.csv"} data={respList}>Export</CSVLink></Button>  */}
    //           </Col>
    //         </Row>
    //       </Form>
    //       <div>
    //         <b>Total Donations:</b>$ {amount}
    //       </div>
    //     </div>
    //     {/* <div className="col-lg-2 col-md-2 col-sm-2">
    //     <button class="btn btn-primary button" onClick={addUser}>Add</button>
    //     </div>   */}
    //   </div>
    //   <div className='col-lg-12 col-md-12 col-sm-12 '>
    //     <div class=' styled-table '>
    //       <table class='table text-black'>
    //         <thead class='thead-light'>
    //           <tr>
    //             {/* <th>{t("ID")}</th> */}
    //             <th style={{ width: '140px' }}>{t('Payment ID')}</th>
    //             <th>{t('Name')}</th>
    //             <th>{t('Card Type')}</th>
    //             <th>{t('Last 4 Dig. ')}</th>
    //             <th>{t('Donation')}</th>
    //             <th>{t('Service Fee')}</th>
    //             {user.userType === 'A' ? <th>{t('Organization')}</th> : ''}
    //             <th>{t('Cause')}</th>
    //             <th>{t('Donated On')}</th>
    //             <th>{t('Payment Method')}</th>
    //             <th>{t('Kiosk Title')}</th>
    //             <th>{t('Status')} </th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           {renderList
    //             ? renderList.map((output) => (
    //                 // onClick={()=>{editUser(output)}}
    //                 <tr className='row-hover'>
    //                   {/* <td >{output.userId}</td> */}
    //                   {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
    //                   <td style={{ width: '120px' }}>{output.paymentId}</td>
    //                   <td
    //                     style={{ width: '200px' }}
    //                     onClick={() => {
    //                       userInfo(output.donorId);
    //                     }}
    //                   >
    //                     <a style={{ color: 'blue', textDecoration: 'underline' }}>
    //                       {output.firstName ? output.firstName : ' '} {output.lastName ? output.lastName : ' '}
    //                     </a>
    //                   </td>
    //                   <td style={{ width: '120px' }}>{output.cardType}</td>
    //                   <td style={{ width: '160px' }}>{output.last4}</td>
    //                   {/* <td style={{width:"160px"}}>{output.currency?output.currency:"USD"} {output.amount}</td> */}
    //                   <td style={{ width: '120px' }}>
    //                     {output.currency === 'USD' ? '$' : '$'} {output.amount}
    //                   </td>
    //                   <td style={{ width: '120px' }}>
    //                     {output.currency === 'USD' ? '$' : '$'} {output.serviceFee ? (output.serviceFee <= 0.009 && output.serviceFee > 0 ? Number(output.serviceFee).toFixed(4) : Number(output.serviceFee).toFixed(2)) : '0.00'}
    //                   </td>
    //                   {user.userType === 'A' ? <td style={{ width: '160px' }}>{output.organizationName}</td> : ''}
    //                   <td style={{ width: '170px' }}>{output.cause}</td>
    //                   <td style={{ width: '160px' }}>{output.donationDate}</td>
    //                   <td style={{ width: '120px' }}>{output.paymentMethod}</td>
    //                   <td style={{ width: '160px' }}>{output.kioskTitle}</td>
    //                   <td style={{ width: '150px' }}>{output.status}</td>
    //                   {/* <td> */}
    //                   {/* <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={()=>{editUser(output)}} /> */}
    //                   {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
    //                      {t('Edit')}
    //                    </button> */}
    //                   {/* </td> */}
    //                 </tr>
    //               ))
    //             : ' '}
    //         </tbody>
    //       </table>
    //       {renderList && renderList.length == 0 ? <NoRecordFound /> : ' '}
    //     </div>
    //     <Modal show={show} onHide={handleClose}>
    //       <Modal.Header closeButton>
    //         <Modal.Title className='text-center'>Donor Information</Modal.Title>
    //       </Modal.Header>
    //       <Modal.Body>
    //         {' '}
    //         <form>
    //           <fieldset disabled>
    //             <div class='form-group mt-2'>
    //               <div className='row '>
    //                 <div className='col-lg-4 mt-1'>Name </div>
    //                 <div className='col-lg-7'>
    //                   <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={`${donorObj.firstName} ${donorObj.lastName}`} />
    //                 </div>
    //               </div>
    //             </div>
    //           </fieldset>
    //           <fieldset disabled>
    //             <div class='form-group mt-2'>
    //               <div className='row '>
    //                 <div className='col-lg-4 mt-1'>Email </div>
    //                 <div className='col-lg-7'>
    //                   <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={`${donorObj.email}`} />
    //                 </div>
    //               </div>
    //             </div>
    //           </fieldset>
    //           <fieldset disabled>
    //             <div class='form-group mt-2'>
    //               <div className='row '>
    //                 <div className='col-lg-4 mt-1'>Mobile </div>
    //                 <div className='col-lg-7'>
    //                   <input type='text' id='disabledTextInput' class='form-control ' placeholder='Disabled input' value={`${donorObj.phone}`} />
    //                 </div>
    //               </div>
    //             </div>
    //           </fieldset>
    //           {/* <fieldset disabled>
    // <div class="form-group mt-2">
    //   <div className='row '>
    //     <div className='col-lg-4 mt-1'>Address </div>
    //     <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`${donorObj.address?donorObj.address:" "}`} /></div>
    //   </div>
    // </div>
    // </fieldset> */}
    //         </form>
    //       </Modal.Body>
    //       <Modal.Footer>
    //         <Button
    //           onClick={() => {
    //             setShow(false);
    //           }}
    //         >
    //           Close
    //         </Button>
    //       </Modal.Footer>
    //     </Modal>
    //   </div>
    //   
    // </div>
  );
}

export default DonationHistory;
